module.exports = __webpack_public_path__ + "img/AQ.413eaf1f.png";